import BenefitForm from './BenefitForm'

export default BenefitForm
